import { clearUser, identifyUser, reportError, trackAction } from './analytics';

// A hook over a module singleton, so there is no provider and no context. That
// is deliberate: it means <PostHogProvider> comes out of the three entry.client
// files with nothing replacing it, and every call site loses its optional chain.
export const useAnalytics = () => ({
  trackAction,
  identifyUser,
  clearUser,
  reportError,
});
